import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function PayModeForm() {
    const navigate = useNavigate();
    const { id } = useParams();

    const isEdit = Boolean(id);

    const [list, setList] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        desc: "",
        status: "Active",
    });

    //  Load data
    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("paymode")) || [];

        setList(saved);

        if (isEdit && saved.length > 0) {
            const item = saved.find((l) => String(l.id) === String(id));
            if (item) {
                setFormData(item);
            }
        }
    }, [id, isEdit]);

    //  Save
    const handleSubmit = () => {
        if (!formData.name || !formData.desc) {
            return alert("All fields required");
        }

        let updatedList = [];

        if (isEdit) {
            updatedList = list.map((l) =>
                String(l.id) === String(id)
                    ? { ...formData, id: l.id }
                    : l
            );
        } else {
            updatedList = [
                { ...formData, id: Date.now() },
                ...list,
            ];
        }

        localStorage.setItem("paymode", JSON.stringify(updatedList));
        setList(updatedList);

        navigate("/admin/paymode");
    };

    return (
        <div style={{ padding: "20px" }}>
            <h2>{isEdit ? "Update Pay Mode" : "Add Pay Mode"}</h2>

            <input
                placeholder="Paymode Name"
                value={formData.name}
                onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                }
            />

            <br /><br />

            <input
                placeholder="Paymode Desc"
                value={formData.desc}
                onChange={(e) =>
                    setFormData({ ...formData, desc: e.target.value })
                }
            />

            <br /><br />

            <select
                value={formData.status}
                onChange={(e) =>
                    setFormData({ ...formData, status: e.target.value })
                }
            >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>

            <br /><br />

            <button onClick={handleSubmit}>
                {isEdit ? "Update" : "Save"}
            </button>

            <button onClick={() => navigate("/admin/paymode")}>
                Cancel
            </button>
        </div>
    );
}